import { render, staticRenderFns } from "./udatalists1.vue?vue&type=template&id=a75946d4&scoped=true&"
import script from "./udatalists1.vue?vue&type=script&lang=js&"
export * from "./udatalists1.vue?vue&type=script&lang=js&"
import style0 from "./udatalists1.vue?vue&type=style&index=0&id=a75946d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75946d4",
  null
  
)

export default component.exports